module.exports = __webpack_public_path__ + "static/media/ready-order.1a29edd5.svg";